/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { DeleteProjectsProjectidSelectionsProjectselectionidOptions, DeleteProjectsProjectidSelectionsProjectselectionidResponses } from '../types/DeleteProjectsProjectidSelectionsProjectselectionid'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /projects/:projectId/selections/:projectSelectionId}
 */
export function deleteProjectsProjectidSelectionsProjectselectionid<ThrowOnError extends boolean = true>(options: Options<DeleteProjectsProjectidSelectionsProjectselectionidOptions, ThrowOnError>): Unwrappable<RequestResult<DeleteProjectsProjectidSelectionsProjectselectionidResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'DELETE', url: '/projects/{projectId}/selections/{projectSelectionId}', security: [{ type: 'http', scheme: 'bearer' }], responseType: 'text', ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<DeleteProjectsProjectidSelectionsProjectselectionidResponses, ThrowOnError>>)
}
